import { HeroCms } from '@cerifi/ui/cms/hero/hero.cms'

import { ComponentHero } from '../../../__generated/graphql.types'

const Hero = (props: { content: ComponentHero }) => {
  return (
    <HeroCms
      isH1={(props.content as any).IS_H1}
      id={props.content.sys.id}
      title={props.content.title}
      description={props.content.description}
      align={props.content.alignment as any}
      img={
        props.content.img
          ? {
              alt: props.content.img.description || '',
              href: props.content.img.url || '',
              pixelatedUrl: props.content.img.pixelatedUrl || '',
            }
          : undefined
      }
      button={props.content.button}
      imageShape={props.content.imageShape}
      backgroundShape={props.content.backgroundShape}
      color={props.content.color}
      eyebrow={props.content.eyebrow}
    />
  )
}

export default Hero
